import {Component, inject, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {DataType} from '../elements/element-multi-select/element-multi-select.component';
import {ProductStore} from '../../store/product.store';

@Component({
  selector: 'app-product-filter',
  templateUrl: './product-filter.component.html',
  styleUrls: ['./product-filter.component.scss']
})
export class ProductFilterComponent implements OnInit {
  readonly DataType = DataType;

  @Input() selectedProducts: string[];
  @Input() cssClasses: string[] = [];
  @Output() productChanged = new EventEmitter<string[]>();

  private readonly productStore = inject(ProductStore);

  readonly productNames = this.productStore.productNames;
  readonly productDefaults = this.productStore.productDefaults;

  ngOnInit(): void {
    this.productStore.loadProducts();
  }

  onSelectionChanged(event: string[]): void {
    if (event?.length === 0) {
      return;
    }
    this.productChanged.emit(event);
  }
}
